import React from 'react';
import { ChromePicker } from 'react-color';
import { withStyles } from '@material-ui/core/styles';

const ColourPickerCss = withStyles((theme) => ({
    '@global': {
        '.chrome-picker': {
            width: '100% !important',
            '& > div:nth-child(2)': {
                fontFamily: theme.typography.fontFamily
            },
            '& > div:nth-child(2) > div:first-child': {
                alignItems: 'center',
                '& > div:first-child > div': {
                    marginTop: '0 !important'
                },
                '& > div:last-child > div:first-child': {
                    marginBottom: '0 !important'
                },
                '& > div:last-child > div:last-child': {
                    display: 'none'
                }
            },
            '& > div:nth-child(2) > div:last-child > div:first-child > div:first-child > div:first-child': {
                display: 'flex',
                alignItems: 'center',
                columnGap: '10px',
                '& > label': {
                    marginTop: '0 !important'
                }
            },
            '& > div:nth-child(2) > div:last-child > div:last-child': {
                display: 'none'
            },
            '& #rc-editable-input-1': {
                borderRadius: '3px !important',
                border: '1px solid ' + theme.palette.background.main,
                '&:focus': {
                    outline: 'none'
                }
            }
        }
    }
}))(() => null);

class HexColourPicker extends React.Component {
    constructor (props) {
        super(props);
    }

    render () {
        const { color, changeColor } = this.props;
        return (
            <div>
                <ColourPickerCss />
                <ChromePicker
                    color={color}
                    onChangeComplete={(e) => changeColor(e.hex)}
                />

            </div>
        );
    }
}

export default HexColourPicker;